import styled from 'styled-components';
import { Form } from '@unform/web';

export const Container = styled.div`
  flex: 1;
  display: flex;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  margin-top: 3.42rem;
  margin-left: 4.4rem;

  // border: 2px solid red;

  svg {
    width: 50px;
    height: 50px;
  }

  // 760px
  @media (max-width: 47.5rem) {
    margin-top: 3.9rem;
    margin-left: 0;
  }
`;

export const FormView = styled(Form)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 10px;
  position: absolute;
  top: 120px;
  left: 100px;
  z-index: 2;

  table {
    thead {
      tr {
        td {
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
    tbody {
      tr {
        // border: 2px solid red;

        td {
          padding: 8px 5px;
          font-size: 14px;

          div {
            padding: 5px;

            input {
              width: 100px;
            }
          }
        }

        td:last-child {
          padding-left: 10px;
        }
      }
    }
  }

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0 5px;

    button {
      background-color: var(--azul-razio);
      color: #fff;
      font-size: 18px;
      font-weight: 600;
      border: 1px solid var(--azul-razio);
      border-radius: 10px;
      padding: 10px 30px;
    }
  }
`;

export const MapView = styled.div`
  display: flex;
  border: 2px solid var(--gray-border-md);
  border-radius: 8px;
  width: 100%;
  height: 100%;
  z-index: 1;

  .icon-marker {
    border-radius: 50%;
  }
`;
